// src/components/RootWrapper.jsx
import React, { useEffect, useState } from "react";
import Loader from "./Loader";

const RootWrapper = ({ element }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // initial hydration
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return <>{element}</>;
};

export default RootWrapper;
